// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__3iCQe","placeHolderShimmer":"divider_placeHolderShimmer__1EAMX"};